

const HindiBksHome = () => {
  // const [searchBook,setSearchBook] = useState('');
  //   const {data: books ,ispending,erroralert} = useFetch(`${process.env.REACT_APP_BOOKS_SERVER_URL}/HindiBooks`);
    return (  
      <div className="homeenglishbooks">
      <h1>Page not ready... This section is under development. check back later</h1>
    </div>
    );
}
export default HindiBksHome;